import pluralize from 'pluralize'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useStatsPermission } from 'app/webview/pages/stats_profile/lib/hooks'
import { StatsProfileBox } from '../../../shared/stats_profile_box'
import { ReaderInsight } from '../../../shared/ReaderInsight'
import { getName } from 'utils'
import capitalize from 'lodash/capitalize'
import { StreakMapContent } from './StreakMapContent'
import { useState } from 'react'
import { analytics } from 'segment_analytics'
import { useChartQuery } from './hooks/useChartQuery'
import { calcCounDaysRead } from './utils'

export const StreakMap = () => {
  const [shouldFetch, setShouldFetch] = useState(false)
  const query = useChartQuery({ enabled: shouldFetch })
  const [yearStatus, stats, isSelfView] = useStats((s) => [
    s.yearStatus,
    s.stats,
    s.isSelfView,
  ])

  const total = calcCounDaysRead(query.data?.data || [])
  const zeroState = total === 0
  const { isStatsOwner, isPlusUser, isAndroid } = useStatsPermission()
  const id = 'streaks-calendar-map'
  const statsUserName = getName(stats?.user?.display_name)?.first
  const firstName = statsUserName ? capitalize(statsUserName) : ''

  if (!isPlusUser || isAndroid) return null

  const queryLoaded = shouldFetch && !query.isIdle && query.isFetched

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      onViewed={() => !shouldFetch && setShouldFetch(true)}
      text={{
        top: `${isSelfView ? 'You’ve' : firstName} read`,
        main: pluralize('day', total, true),
        unit: '',
        infoText: (
          <>
            <b>How do I read this chart?</b>
            <br />
            The x-axis represents months and the squares represent days of the
            year.
            <br />
            <br />
            <b>How do I edit this data?</b>
            <br />
            For “Best streak” and “Days read”, go to Profile &gt; Settings &gt;
            Edit Streaks Log. For “Finished” make sure your books have Finished
            dates that include a month, day, and year.
          </>
        ),
      }}
      textAnim={{
        trigger: 'data',
        loaded: queryLoaded,
      }}
      footer={
        queryLoaded && isStatsOwner && zeroState && yearStatus === 'current' ? (
          <ReaderInsight
            data-testid="reader-insight-authors"
            label="How to get started"
            text="Start using Streaks in the Home tab and mark books with a MM/DD/YYYY finished date to get started!"
          />
        ) : null
      }
      screenshot={{
        enabled: !zeroState,
        component: <StreakMapContent skipAnim />,
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'days_read_full_year' }),
      }}
    >
      <StreakMapContent />
    </StatsProfileBox>
  )
}

// box-shadow: 0px 6px 16px 0px #0000001F; 12%
